import { render, staticRenderFns } from "./GiveConsent.vue?vue&type=template&id=163d3f59&scoped=true"
import script from "./GiveConsent.vue?vue&type=script&lang=js"
export * from "./GiveConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163d3f59",
  null
  
)

export default component.exports